.container {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  & > div:first-child {
    display: none;
  }

  @media screen and (min-width: #{$bp-medium - 1}) {
    & > div:first-child {
      display: flex;
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: calc(100%);
  overflow: hidden;
  transition: all 0.2s ease-in;

  @media screen and (min-width: $bp-medium) {
    &[data-expand='true'] {
      max-width: calc(100% - 200px);
    }
  }
}

.header {
  height: 4rem;
  min-height: 4rem;
  width: 100%;
  border-bottom: 1px var(--content-border-color) solid;
  color: #e3e4e7;
  font-size: 1.4rem;
  font-weight: 600;
  padding: 0 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  svg {
    height: 1.6rem;
    width: 1.6rem;
  }
}

.archived-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 1.6rem;
  background-color: rgba(255, 165, 0, 0.1);
  border-bottom: 1px solid rgba(255, 165, 0, 0.3);
  color: var(--color-grayscale-white);
  font-size: 1.4rem;
  gap: 1.6rem;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 0.8rem;

  svg {
    width: 1.6rem;
    height: 1.6rem;
    color: #ffa500;
  }
}
